// Present the two dimensions of Line glove's combined Shopify option separately.
// The original radio remains the sole source of variant, price, and inventory state.
const pickerSelector = '[data-ao-hand-picker]';
const delimiter = /\s+[—–]\s+/;

function getParts(value) {
  const parts = value.split(delimiter);
  return parts.length === 2 && parts[0] && parts[1] ? parts : null;
}

function displayHand(value, language) {
  if (!language.toLowerCase().startsWith('es')) return value;
  if (/^right hand$/i.test(value)) return 'Mano derecha';
  if (/^left hand$/i.test(value)) return 'Mano izquierda';
  return value;
}

function makeGroup(label, dimension, values, selected, language) {
  const group = document.createElement('div');
  group.className = 'ao-hand-picker__group';
  group.setAttribute('role', 'group');
  group.setAttribute('aria-label', label);

  const heading = document.createElement('span');
  heading.className = 'ao-hand-picker__heading';
  heading.textContent = label;
  group.append(heading);

  const choices = document.createElement('div');
  choices.className = 'ao-hand-picker__choices';
  for (const value of values) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ao-hand-picker__button';
    button.dataset.aoDimension = dimension;
    button.dataset.aoValue = value;
    button.setAttribute('aria-pressed', String(value === selected));
    button.textContent = dimension === 'hand' ? displayHand(value, language) : value;
    choices.append(button);
  }
  group.append(choices);
  return group;
}

function syncPicker(container) {
  const native = container.nextElementSibling;
  if (!(native instanceof HTMLFieldSetElement) || !native.hasAttribute('data-ao-combined-hand-option')) return;

  const radios = [...native.querySelectorAll('input[type="radio"]')];
  const parsed = radios.map((radio) => ({ radio, parts: getParts(radio.value) }));
  if (parsed.length !== 4 || parsed.some(({ parts }) => !parts)) {
    container.classList.remove('ao-hand-picker--ready');
    return;
  }

  const lengths = [...new Set(parsed.map(({ parts }) => parts[0]))];
  const hands = [...new Set(parsed.map(({ parts }) => parts[1]))];
  if (lengths.length !== 2 || hands.length !== 2) {
    container.classList.remove('ao-hand-picker--ready');
    return;
  }

  const chosen = getParts(radios.find((radio) => radio.checked)?.value || '') || parsed[0].parts;
  const signature = JSON.stringify({ lengths, hands, lengthLabel: container.dataset.lengthLabel, handLabel: container.dataset.handLabel });
  if (container.dataset.aoSignature !== signature) {
    container.replaceChildren(
      makeGroup(container.dataset.lengthLabel || 'Glove length', 'length', lengths, chosen[0], document.documentElement.lang),
      makeGroup(container.dataset.handLabel || 'Hand', 'hand', hands, chosen[1], document.documentElement.lang)
    );
    container.dataset.aoSignature = signature;
  }

  for (const button of container.querySelectorAll('button[data-ao-dimension]')) {
    const selected = button.dataset.aoDimension === 'length' ? chosen[0] : chosen[1];
    const active = button.dataset.aoValue === selected;
    if (button.getAttribute('aria-pressed') !== String(active)) {
      button.setAttribute('aria-pressed', String(active));
    }
  }
  container.classList.add('ao-hand-picker--ready');
}

function syncAll() {
  document.querySelectorAll(pickerSelector).forEach(syncPicker);
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('button[data-ao-dimension]');
  const container = button?.closest(pickerSelector);
  const native = container?.nextElementSibling;
  if (!(button instanceof HTMLButtonElement) || !(native instanceof HTMLFieldSetElement)) return;

  const current = getParts(native.querySelector('input[type="radio"]:checked')?.value || '');
  if (!current) return;
  const length = button.dataset.aoDimension === 'length' ? button.dataset.aoValue : current[0];
  const hand = button.dataset.aoDimension === 'hand' ? button.dataset.aoValue : current[1];
  const matching = [...native.querySelectorAll('input[type="radio"]')]
    .find((radio) => {
      const parts = getParts(radio.value);
      return parts && parts[0] === length && parts[1] === hand;
    });
  if (matching && !matching.checked) matching.click();
});

document.addEventListener('change', (event) => {
  if (!(event.target instanceof Element)) return;
  const native = event.target.closest('fieldset[data-ao-combined-hand-option]');
  const container = native?.previousElementSibling;
  if (container?.matches(pickerSelector)) queueMicrotask(() => syncPicker(container));
});

let syncScheduled = false;
const observer = new MutationObserver(() => {
  if (syncScheduled) return;
  syncScheduled = true;
  requestAnimationFrame(() => {
    syncScheduled = false;
    syncAll();
  });
});

function start() {
  syncAll();
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
